export default __webpack_public_path__ + "static/media/sfp-chronopost_fr.e9767a1a.svg";